/**
 * sourceAppCatalog — hard-coded app list for the Gate 1 source picker.
 *
 * TDD §3d.1.C: This is a frontend-only constant. Do NOT derive from the backend,
 * API responses, or any Redux state. No network round-trip fetches this list.
 *
 * CampMinder is the only enabled source in v1.
 * The other 5 show "Coming soon" per brand guide §29.
 */
export interface SourceApp {
  readonly code: string
  readonly name: string
  readonly enabled: boolean
  /**
   * If true, the card spans both columns of the 2-col grid (Google Sheets).
   * Part of the hard-coded visual layout documented in the mockup and TDD §3d.1.C.
   */
  readonly fullWidth?: boolean
}

export const SOURCE_APP_CATALOG = [
  { code: 'camp_minder',   name: 'CampMinder',    enabled: true  },
  { code: 'survey_monkey', name: 'SurveyMonkey',  enabled: false },
  { code: 'camp_brain',    name: 'CampBrain',     enabled: false },
  { code: 'camp_doc',      name: 'CampDoc',       enabled: false },
  { code: 'camp_site',     name: 'CampSite',      enabled: false },
  { code: 'google_sheets', name: 'Google Sheets', enabled: false, fullWidth: true },
] as const satisfies readonly SourceApp[]

/** Literal-union type of every source app code. */
export type SourceAppCode = typeof SOURCE_APP_CATALOG[number]['code']

/** Entry type for disabled apps (narrowed from the catalog via its `enabled: false` literal). */
type DisabledSourceAppEntry = Extract<typeof SOURCE_APP_CATALOG[number], { enabled: false }>

/**
 * Pre-computed subset of disabled apps. Module-level so it is not reallocated per render.
 * Typed as `readonly DisabledSourceAppEntry[]` so downstream consumers see `code` as the
 */
export const DISABLED_SOURCE_APPS: readonly DisabledSourceAppEntry[] =
  SOURCE_APP_CATALOG.filter((app): app is DisabledSourceAppEntry => !app.enabled)
